export default function PlayitasAbout() {
  return (
    <>
      <section className="py-32 px-6 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-500 text-sm tracking-widest mb-4">O NAS</p>
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              Wszystko, czego potrzebujesz do<br />
              <span className="italic">treningów na poziomie elity 🏆</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">Playitas Resort - Twój Partner w Sukcesie</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Playitas Resort to wiodący ośrodek sportowy w Europie, położony na pięknej wyspie
                Fuerteventura na Wyspach Kanaryjskich. Od ponad 20 lat jesteśmy domem dla
                profesjonalnych sportowców, trenerów i zespołów z całego świata.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Nasze światowej klasy obiekty, idealne warunki klimatyczne przez cały rok i doświadczony
                zespół sprawiają, że jesteśmy idealnym miejscem do organizacji obozów treningowych.
              </p>
              <div className="grid grid-cols-2 gap-4 mt-8">
                {["Obiekty olimpijskie", "Klimat przez cały rok", "Zakwaterowanie all-inclusive", "Wsparcie 24/7"].map(item => (
                  <div key={item} className="flex items-start gap-3">
                    <i className="ri-check-line text-2xl text-orange-500 mt-0.5" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img src="https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2025-10/resort_view.JPG?h=9da35737&itok=GPl7SPq-"
                alt="Playitas Resort widok" className="w-full h-full object-cover object-center" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-32 px-6 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #F97316, #FB923C, #FBBF24)" }}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-96 h-96 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl" />
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="text-white">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
                <span className="text-white font-bold text-sm tracking-wider">🎁 OFERTA EKSKLUZYWNA DLA TRENERÓW</span>
              </div>
              <h2 className="text-5xl md:text-6xl font-black mb-6 leading-tight">TYDZIEŃ GRATIS W PLAYITAS RESORT</h2>
              <p className="text-2xl mb-8 text-white/95 leading-relaxed">
                Jesteś trenerem personalnym w Polsce? Otrzymaj{" "}
                <strong>bezpłatne zakwaterowanie na tydzień</strong> w zamian za udział w naszym programie treningowym!
              </p>
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 mb-8 border-2 border-white/30">
                <h3 className="text-2xl font-bold mb-6">Co otrzymujesz:</h3>
                <ul className="space-y-4">
                  {[
                    { icon: "ri-hotel-line", title: "7 dni zakwaterowania ALL-INCLUSIVE", desc: "Pełne wyżywienie i dostęp do wszystkich obiektów" },
                    { icon: "ri-dumbbell-line", title: "Udział w programie treningowym", desc: "Prowadź sesje treningowe dla naszych gości" },
                    { icon: "ri-eye-line", title: "Poznaj resort od środka", desc: "Idealna okazja do zaplanowania przyszłego obozu" },
                    { icon: "ri-team-line", title: "Networking z profesjonalistami", desc: "Poznaj innych trenerów z całej Europy" },
                  ].map(item => (
                    <li key={item.title} className="flex items-start gap-4">
                      <div className="w-8 h-8 flex items-center justify-center bg-white rounded-full flex-shrink-0 mt-1">
                        <i className={`${item.icon} text-xl text-orange-500`} />
                      </div>
                      <div>
                        <p className="font-bold text-lg">{item.title}</p>
                        <p className="text-white/90">{item.desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 mb-8">
                <p className="text-lg"><strong>💡 Idealne dla:</strong> Trenerów CrossFit, Hyrox, Fitness, Personal Trainers z minimum 10K obserwujących w social media</p>
              </div>
              <button onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                className="inline-flex items-center gap-4 bg-white text-orange-500 px-10 py-6 rounded-full text-xl font-black transition-all cursor-pointer whitespace-nowrap shadow-2xl hover:scale-105">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-gift-line text-3xl text-white" />
                </div>
                ZGŁOŚ SIĘ TERAZ
                <i className="ri-arrow-right-line text-2xl" />
              </button>
            </div>
            <div className="relative">
              <div className="relative h-[700px] rounded-3xl overflow-hidden shadow-2xl">
                <img src="https://api.playitas.net/sites/default/files/styles/hero/public/2024-08/Gym_03.JPG?h=10d202d3&itok=biGrUylx"
                  alt="Trener w Playitas Resort" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <div className="absolute bottom-8 left-8 right-8 text-white">
                  <p className="text-2xl font-bold mb-2">Zostań częścią zespołu Playitas</p>
                  <p className="text-lg opacity-90">Doświadcz resortu jak profesjonalista</p>
                </div>
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-2xl p-6">
                <div className="text-4xl font-black text-orange-500 mb-1">100+</div>
                <div className="text-sm text-gray-600">Trenerów rocznie</div>
              </div>
              <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-2xl p-6">
                <div className="text-4xl font-black text-orange-500 mb-1">⭐ 4.9</div>
                <div className="text-sm text-gray-600">Ocena trenerów</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
